import {Sidebar as CoreSidebar, type SidebarProps, type SidebarItemProps} from '@github-ui/layout-primitives-core'
import {memo} from 'react'
import {DotcomLayoutRuntime} from '../dotcom-layout-runtime'

export type {
  SidebarProps,
  SidebarSectionProps,
  SidebarItemProps,
  SidebarAccordionProps,
  SidebarShowMoreProps,
  SidebarCollapseButtonProps,
  SearchProps,
} from '@github-ui/layout-primitives-core'

function Root(props: SidebarProps) {
  return (
    <DotcomLayoutRuntime>
      <CoreSidebar {...props} />
    </DotcomLayoutRuntime>
  )
}

const Item = memo(function SidebarItem(props: SidebarItemProps) {
  return (
    <DotcomLayoutRuntime>
      <CoreSidebar.Item {...props} />
    </DotcomLayoutRuntime>
  )
})

export const Sidebar = Object.assign(Root, {
  ...CoreSidebar,
  Item,
})
